import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useMemberAuth } from '../contexts/MemberAuthContext';

const MemberProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const { member, loading } = useMemberAuth();

  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  if (!member) return <Navigate to="/app/login" replace />;

  return <>{children}</>;
};

export default MemberProtectedRoute;

